import imageOne from '../images/face1.jpg'
import imageTwo from "../images/face2.jpg"
import imageThree from "../images/face3.jpg"
import Starts from "../images/fiveStart.png"

export const TestimonialData = [
    {
        image: imageOne,
        starts: Starts,
        name: 'Birindwa Zihalirwa',
        description: 'A box-shadow CSS generator that helps you quickly generate box-shadow CSS elp easily get fonts at Font Keyboard iOS app and Font Keyboard Android app.',


    },
    {
        image: imageTwo,
        starts: Starts,
        name: 'Birindwa Zihalirwa',
        description: "A box-shadow CSS generator that helps you quickly generate box-shadow CSS elp easily get fonts at Font Keyboard iOS app and Font Keyboard Android app.",


    },
    {
        image: imageThree,
        starts: Starts,
        name: 'Birindwa Zihalirwa',
        description: 'A box-shadow CSS generator that helps you quickly generate box-shadow CSS elp easily get fonts at Font Keyboard iOS app and Font Keyboard Android app.',


    },
    {
        image: imageThree,
        starts: Starts,
        name: 'Birindwa Zihalirwa',
        description: 'A box-shadow CSS generator that helps you quickly generate box-shadow CSS elp easily get fonts at Font Keyboard iOS app and Font Keyboard Android app.',


    }
]